/* -------------------------------------------------------------------------------------------------
 * props
 * -----------------------------------------------------------------------------------------------*/

type SvgComponentProps = {
  width?: number
  height?: number
}

/* -------------------------------------------------------------------------------------------------
 * component
 * -----------------------------------------------------------------------------------------------*/

const SvgComponent = ({ height = 64, width = 64 }: SvgComponentProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 32C0 14.3269 14.3269 0 32 0C49.6731 0 64 14.3269 64 32C64 49.6731 49.6731 64 32 64C14.3269 64 0 49.6731 0 32Z"
      fill="#FBE7E7"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.5607 18.4393C19.9749 17.8536 19.0251 17.8536 18.4393 18.4393C17.8536 19.0251 17.8536 19.9749 18.4393 20.5607L29.3787 31.5L18.4393 42.4394C17.8536 43.0251 17.8536 43.9749 18.4393 44.5607C19.0251 45.1465 19.9749 45.1465 20.5607 44.5607L31.5 33.6213L42.4394 44.5607C43.0252 45.1465 43.9749 45.1465 44.5607 44.5607C45.1465 43.9749 45.1465 43.0251 44.5607 42.4394L33.6214 31.5L44.5607 20.5607C45.1465 19.9749 45.1465 19.0251 44.5607 18.4393C43.9749 17.8536 43.0252 17.8536 42.4394 18.4393L31.5 29.3787L20.5607 18.4393Z"
      fill="#C40909"
    />
  </svg>
)

export { SvgComponent as ErrorCirclePS }
